import smoothscroll from 'smoothscroll-polyfill';

import Header from '../components/Header';
import BookingButton from '../components/BookingButton';
import BackgroundSetter from '../components/BackgroundSetter';
import LocationsModal from '../components/LocationsModal';
import ModalHelper from '../components/ModalHelper';
import CollapseHelper from '../components/CollapseHelper';
import Storage from '../util/Storage';
import GtmHelper from '../util/GtmHelper';

export default {
    init() {

        $('.service-item__checkbox-extra').change(function() {
            const services = $(this).closest('[data-service-item]');

            $(services).each(function(index, item) {
                const data = $(item).data('service-item');
                let price = parseFloat(data.price.value);
                let sales_price = 0;
                if (data.sales_price && data.sales_price.value) {
                    sales_price = parseFloat(data.sales_price.value) || 0;
                }

                $(item).find('.service-item__checkbox-extra').each(function() {
                    if ($(this).is(':checked')) {
                        let extra = $(this).data('extra');
                        price += parseFloat(extra.price);
                        sales_price += parseFloat(extra.price);
                    }
                })

                $(item).find('.js-price-with-extras').text(price);
                $(item).find('.js-sales_price-with-extras').text(sales_price);
            });
        });

        $('.js-add-to-booking').click(function() {
            const key = Storage.KEY_SERVICES;
            let services = Storage.getItem(key);
            if (!services) {
                services = [];
            }

            let serviceEl = $(this).closest('[data-service-item]');
            let service = $(serviceEl).data('service-item');
            service.wpid = service.id;

            GtmHelper.addToCart(service);

            let serviceCopy = Object.assign({}, service);
            serviceCopy.id = service.id + new Date().getTime();
            serviceCopy.extras = [];

            $(serviceEl).find('.service-item__checkbox-extra').each(function() {
                let extra = $(this).data('extra');
                extra.checked = $(this).is(':checked');
                serviceCopy.extras.push(extra);
            });

            services.push(serviceCopy);

            Storage.setItem(key, services);

            BookingButton.showTooltip(service);

            // $(this).find('.js-add-to-booking-text').hide();
            $(serviceEl).find('.js-added-to-booking').css('display', 'flex');
            $(serviceEl).find('.js-add-to-booking').hide();
            setTimeout(function() {
                $(serviceEl).find('.js-added-to-booking').hide();
                $(serviceEl).find('.js-add-to-booking').show();
            }, 2000);
        });

        $('#searchIcon').on('click', function() {
            $('#searchForm').removeClass('hidden');
            $('#searchForm input').focus();
        });

        $('#closeSearchForm').on('click', function() {
            $('#searchForm').addClass('hidden');
        });

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        Header.init();
        CollapseHelper.init();
        LocationsModal.init();
        ModalHelper.init();
        BookingButton.init();

        BookingButton.updateCount();

        const bgSetter = new BackgroundSetter();
        bgSetter.setBackgroundImages();

        $(window).resize(function() {
            bgSetter.setBackgroundImages();
        });

        smoothscroll.polyfill();

        (function($) {
            $(document).on('facetwp-loaded', function() {
                $.each(FWP.settings.num_choices, function(key, val) {
                    var $parent = $('.facetwp-facet-' + key).closest('.block-categories--widget');
                    (0 === val) ? $parent.hide() : $parent.show();
                });
            });
        })(jQuery);
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js